import { getOrderRelatedFilmById } from '../films/get-order-related-film-by-id';
import { getOrderRelatedShowtimeById } from './get-order-related-showtime-by-id';
/**
 * Gets the corresponding film for a showtime.
 */
export const getOrderRelatedFilmForShowtime = (showtimeId) => {
    const showtime = getOrderRelatedShowtimeById(showtimeId);
    if (!showtime)
        return undefined;
    return getOrderRelatedFilmById(showtime.filmId);
};
